// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__5qoSj {
  padding: 20px; }

.styles_form__LZVkj {
  max-width: 600px;
  margin: 0 auto; }
`, "",{"version":3,"sources":["webpack://./src/modules/teachings/components/screens/CreateTeachingsBoothScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa,EAAA;;AAGf;EACE,gBAAgB;EAChB,cAAc,EAAA","sourcesContent":[".container {\n  padding: 20px;\n}\n\n.form {\n  max-width: 600px;\n  margin: 0 auto;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__5qoSj`,
	"form": `styles_form__LZVkj`
};
export default ___CSS_LOADER_EXPORT___;
